module.exports = __webpack_public_path__ + "img/ecb5409.svg";